export enum AdOrderEnum {
  DateDesc = 'RANDOM',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
}

export const SORT_OPTIONS = [
  {
    value: AdOrderEnum.PriceAsc,
    tKey: 'shop.sort_asc',
  },
  {
    value: AdOrderEnum.PriceDesc,
    tKey: 'shop.sort_desc',
  },
  {
    value: AdOrderEnum.DateDesc,
    tKey: 'shop.sort_date',
  },
];

export enum KeyboardKey {
  Escape = 'Escape',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
}

export const ADS_PER_PAGE = 20;

export const DEFAULT_SCROLL_STEP_PX = 600;

export const ROOT_CATEGORY_ID = 'root';
